// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__27Atv","question":"Question_question__3QCCB","description":"Question_description__3gLLj"};